import { Checkbox } from "@/components/ui/checkbox";
import { NAV, SA_ONLY, defaultModules } from "@/lib/access";

const groups = () => NAV.filter((n) => !SA_ONLY.includes(n.id) && !n.module).reduce((out, n) => {
  const g = n.group || "General";
  (out[g] = out[g] || []).push(n);
  return out;
}, {});

export const ModulePicker = ({ role, value, onChange }) => {
  if (role === "Super Admin") return <p className="text-sm rounded-md border border-emerald-200 bg-emerald-50 text-emerald-900 p-3" data-testid="staff-modules-all">Super Admin can open every module, including Staff Access Control.</p>;
  const toggle = (id, on) => onChange(on ? [...new Set([...value, id])] : value.filter((m) => m !== id));
  return (
    <div className="rounded-md border border-[#E5E7EB] p-3 space-y-3" data-testid="staff-modules">
      <div className="flex items-center justify-between gap-2">
        <span className="text-xs text-gray-500" data-testid="staff-modules-count">{value.length} module{value.length === 1 ? "" : "s"} selected</span>
        <div className="flex gap-3 text-xs font-semibold">
          <button type="button" onClick={() => onChange(defaultModules(role))} className="text-[#E60000] hover:underline" data-testid="staff-modules-defaults">Use {role} defaults</button>
          <button type="button" onClick={() => onChange([])} className="text-gray-600 hover:underline" data-testid="staff-modules-clear">Clear</button>
        </div>
      </div>
      {Object.entries(groups()).map(([g, items]) => (
        <div key={g}>
          <div className="text-[10px] font-bold uppercase tracking-wider text-gray-400 mb-1.5">{g}</div>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-4 gap-y-2">
            {items.map((n) => (
              <label key={n.id} className="flex items-center gap-2 text-sm cursor-pointer">
                <Checkbox checked={value.includes(n.id)} onCheckedChange={(v) => toggle(n.id, !!v)} data-testid={`staff-module-${n.id}`} />
                <n.icon className="w-4 h-4 text-gray-400" />{n.label}
              </label>
            ))}
          </div>
        </div>
      ))}
      <p className="text-[11px] text-gray-500">Staff Access Control is only for the Super Admin. Permanent deletes also stay with the Super Admin.</p>
    </div>
  );
};
